/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import {
  GlobalConfiguration,
  IntervalConfiguration,
} from "../../../../../utils/configurationProvider";
import {
  panLookUp,
  resetPanLookup,
  verifyPAN,
} from "../../../../../redux/features/sharedResources/sharedResources";
import CommonToast from "../../../../../components/_utils/CommonToast";
import ICONS from "../../../../../assets/Icons";
import {
  editFieldForceAccount,
  getSpecificFieldForceAccount,
  resetEditFieldForceAccount,
} from "../../../../../redux/features/accounts/fieldForceAccount";
import { resetPANVerification } from "../../../../../redux/features/verifyPAN/verifyPAN";
import SmallPopup from "../../../../../components/_utils/CommonSmallPopup";
import PrimaryStepper from "../../../../../components/_utils/CommonSteppers/PrimaryStepper";
import TopNavComponent from "../../../../../components/_utils/CommonTopNav/TopNavComponent";
import FieldForceAccountPanDetails from "../FieldForceAccountPanDetails";

const FieldForceAccountEditPan = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const dispatch = useDispatch();
  const [showPopup, setShowPopup] = useState(false);
  const [nextButtonEnabled, BenEnableNextButton] = useState(true);
  const [showAction, setShowAction] = useState(false);
  const [test, setTest] = useState(true);
  const [openPopEdit, setOpenPopEdit] = useState(false);
  const [alreadyLinked, setAlreadyLinked] = useState(false);
  const [nonArchive, setNonArchive] = useState(false);
  const [isFocus, setIsFocus] = useState(false);
  const [accountType, setAccountType] = useState({ type: "", id: "" });
  const [lookupNext, setLookupNext] = useState(false);
  const [disableCreateNext, setDisableCreateNext] = useState(false);
  const [shutViewAll, setShutViewAll] = useState(false);
  const [isAchived, setIsArchived] = useState(false);
  const [isBlock, setIsBlock] = useState(false);
  const [isApproved, setIsApproved] = useState(false);
  const [isDennied, setIsDennied] = useState(false);
  const [isPending, setIsPending] = useState(false);
  const [verifiedPan, setVerifiedPan] = useState(null);
  const [newMessage, setNewMessage] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const [hideCreate, setHideCreate] = useState(false);
  const [hideBlock, setHideBlock] = useState(false);
  const [previousBankNo, setPreviousBankNo] = useState("");
  const [isLinkedAccount, setIsLinkedAccount] = useState(false);
  const [achivedOpenPop, setAchivedOpenPop] = useState(false);
  const [unachivedOpenPop, setUnachivedOpenPop] = useState(false);
  const [showAccInfo, setShowAccInfo] = useState(false);
  const [handleUpdateNext, setHandleUpdateNext] = useState(false);

  const [cancelBut, setCanclebtn] = useState(false);
  const [isBankLinkedToThisPan, setIsBankLinkedToThisPan] = useState(null);
  const [showRejectTnxPopup, setRejectTxnPopup] = useState(false);
  const [payload, setPayload] = useState({
    bank_account: "",
    ifsc_code: "",
    contact_no: "",
    email_id: "",
    name: "",
    categories: "",
    panNumber: "",
  });
  const [updateActive, setUpdateActive] = useState(false);

  const {
    panLookupData,
    panLookupLoading,
    panLookupError,
    panVerificationData,
    panVerificationLoading,
  } = useSelector((state) => state.sharedResources);

  const [associatedPan, setAssociatedPan] = useState(true);
  const [accActiveInactiveState, setAccActiveInactiveState] =
    useState("active");
  const [currentAssociate, setCurrentAssociate] = useState(
    "Field force account",
  );

  const [openPopEditCheck, setOpenPopEditCheck] = useState(false);
  const verifyDebounceRef = useRef(null);
  const retryCountRef = useRef(GlobalConfiguration.lengthCheckZero);
  const pendingVerifyPanRef = useRef(null);
  const abortControllerRef = useRef(null);
  const lastLookupRef = useRef({ pan: null, page: null });
  const cachedLookupPanRef = useRef(null);
  const cachedLookupAccountsRef = useRef([]);
  const VERIFY_DEBOUNCE_MS = IntervalConfiguration.intervalTiny;

  const syncLookupCache = (pan, accounts) => {
    if (pan && accounts?.length) {
      cachedLookupPanRef.current = pan;
      cachedLookupAccountsRef.current = accounts;
    }
  };

  const getLookupAccountsForCurrentPan = () => {
    const pan = payload.panNumber;
    if (pan?.length !== GlobalConfiguration.panLength) {
      return [];
    }
    if (allData?.length > GlobalConfiguration.lengthCheckZero) {
      return allData;
    }
    if (
      panLookupData?.status &&
      cachedLookupPanRef.current === pan &&
      cachedLookupAccountsRef.current.length >
        GlobalConfiguration.lengthCheckZero
    ) {
      return cachedLookupAccountsRef.current;
    }
    if (
      panLookupData?.status &&
      lastLookupRef.current.pan === pan &&
      panLookupData?.beneficiary_accounts?.length
    ) {
      return panLookupData.beneficiary_accounts;
    }
    return [];
  };

  const {
    editFieldForceAccountData,
    editFieldForceAccountError,
    getSpecificFieldForceAccountData,
    getSpecificFieldForceAccountLoading,
  } = useSelector((state) => state.fieldForceAccount);
  const { services, isLoading } = useSelector((state) => state.refreshToken);
  const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
  const specialRegex = /^[a-zA-Z0-9 ]*$/;

  const [allData, setAllData] = useState([]);
  const [page, setPage] = useState(1);

  const fieldForceAccount =
    getSpecificFieldForceAccountData?.field_force_accounts?.[
      GlobalConfiguration.lengthCheckZero
    ];
  const currentBankAccNo = fieldForceAccount?.bank_acc_no;

  const haveLinkNew = allData?.some((val) => {
    return val?.bank_acc_no === currentBankAccNo && val?.id !== id;
  });

  const dispatchLookupIfNeeded = (
    pan,
    pageNo = GlobalConfiguration.lengthCheckOne,
  ) => {
    if (!pan || alreadyLinked) return;
    if (
      lastLookupRef.current.pan === pan &&
      lastLookupRef.current.page === pageNo
    ) {
      return;
    }
    lastLookupRef.current = { pan, page: pageNo };
    dispatch(panLookUp({ pan_number: pan, page: pageNo }));
  };

  const getVerifiedPanFromResponse = () => {
    const panFromResponse =
      panVerificationData?.pan_details?.pan_number ||
      panVerificationData?.pan_details?.pan;
    return panFromResponse ? String(panFromResponse).toUpperCase() : "";
  };

  useEffect(() => {
    if (!panVerificationLoading) {
      if (
        pendingVerifyPanRef.current != null &&
        payload.panNumber !== pendingVerifyPanRef.current
      ) {
        return;
      }
      const isCurrentPanFullLength =
        payload.panNumber?.length === GlobalConfiguration.panLength;
      const responsePan = getVerifiedPanFromResponse();
      if (responsePan && responsePan !== payload.panNumber?.toUpperCase()) {
        return;
      }
      if (panVerificationData?.status === true) {
        if (isCurrentPanFullLength) {
          retryCountRef.current = GlobalConfiguration.lengthCheckZero;
          setVerifiedPan(true);

          if (services?.includes("FFUAccount") || services?.includes("Admin")) {
            dispatchLookupIfNeeded(payload.panNumber, 1);
          } else {
            navigate("/feature_not_assigned", {
              state: { unavailableService: "FFUAccount" },
            });
          }

          setPayload({
            ...payload,
            legalName: panVerificationData?.pan_details?.full_name,
          });
        }
      } else if (panVerificationData?.status === false) {
        if (isCurrentPanFullLength) {
          setVerifiedPan(false);
          setPayload({
            ...payload,
            gstin: "",
          });

          CommonToast({
            text: panVerificationData?.errors?.base?.[
              GlobalConfiguration.lengthCheckZero
            ],
            icon: ICONS?.INFO_FILLED,
            variant: "var(--error)",
            buttonNeeded: false,
          });
        }
      }
    }
  }, [panVerificationData, payload.panNumber, services, navigate, dispatch]);

  useEffect(() => {
    let gstStoredData = sessionStorage.getItem("PAN GST Edit NewValue");
    const lookupPan = lastLookupRef.current.pan;
    const isLookupForCurrentPan =
      lookupPan === payload.panNumber &&
      payload.panNumber?.length === GlobalConfiguration.panLength;

    if (!panLookupLoading && panLookupData?.status && isLookupForCurrentPan) {
      if (allData?.length === GlobalConfiguration.lengthCheckZero) {
        const accounts = panLookupData?.beneficiary_accounts ?? [];
        syncLookupCache(payload.panNumber, accounts);
        setAllData((allData) => [...allData, ...accounts]);

        const totalRecords =
          panLookupData?.title?.records ?? GlobalConfiguration.lengthCheckZero;
        const firstPageLength =
          panLookupData?.beneficiary_accounts?.length ??
          GlobalConfiguration.lengthCheckZero;
        if (
          totalRecords > firstPageLength &&
          (services?.includes("FFUAccount") || services?.includes("Admin"))
        ) {
          setPage(2);
          dispatchLookupIfNeeded(payload.panNumber, 2);
        }

        if (panLookupData?.title?.records > allData?.length) {
          setTest(false);
        } else {
          setTest(true);
        }
      } else if (panLookupData?.title?.records > allData?.length) {
        const totalRecords =
          panLookupData?.title?.records ?? GlobalConfiguration.lengthCheckZero;
        const newAccounts = panLookupData?.beneficiary_accounts ?? [];
        const currentLength =
          allData?.length ?? GlobalConfiguration.lengthCheckZero;
        const willHaveAll = currentLength + newAccounts.length >= totalRecords;

        setAllData((prevAllData) => {
          const merged = [...prevAllData, ...newAccounts];
          syncLookupCache(payload.panNumber, merged);
          return merged;
        });

        if (
          !willHaveAll &&
          (services?.includes("FFUAccount") || services?.includes("Admin"))
        ) {
          const nextPage = page + GlobalConfiguration.lengthCheckOne;
          dispatchLookupIfNeeded(payload.panNumber, nextPage);
          setPage((prevPage) => prevPage + GlobalConfiguration.lengthCheckOne);
        } else if (!willHaveAll) {
          navigate("/feature_not_assigned", {
            state: { unavailableService: "FFUAccount" },
          });
        }

        if (!willHaveAll) {
          setTest(false);
        } else {
          setTest(true);
        }
      }
    }

    const allDataLoaded =
      allData &&
      !panLookupLoading &&
      allData?.length === panLookupData?.title?.records;

    if (allDataLoaded) {
      const hasId = allData.some((val) => val?.id === id);
      setAssociatedPan(hasId);
    } else if (!panLookupLoading && panLookupError && !allData) {
      BenEnableNextButton(false);
      setAssociatedPan(false);
      setAlreadyLinked(false);
      setIsLinkedAccount(false);
    }

    if (
      haveLinkNew === undefined ||
      (haveLinkNew === false && !panLookupLoading)
    ) {
      setNewMessage(false);
    }
  }, [
    panLookupData,
    id,
    panLookupError,
    allData,
    panLookupLoading,
    verifiedPan,
    payload.panNumber,
    haveLinkNew,
    getSpecificFieldForceAccountData,
  ]);

  useEffect(() => {
    const pan = payload.panNumber;
    const originalPan = fieldForceAccount?.pan_no;
    const isFullPan = pan?.length === GlobalConfiguration.panLength;

    if (!isFullPan) {
      setAlreadyLinked(false);
      setIsLinkedAccount(false);
      return;
    }

    if (verifiedPan !== true) {
      return;
    }

    if (panLookupLoading) {
      return;
    }

    const lookupAccounts = getLookupAccountsForCurrentPan();
    if (!lookupAccounts.length) {
      return;
    }

    syncLookupCache(pan, lookupAccounts);

    const isPanChangedFromOriginal = pan !== originalPan;

    let bankLinkedToThisPan = lookupAccounts?.find((val) => {
      return (
        isPanChangedFromOriginal &&
        currentBankAccNo &&
        val?.bank_acc_no === currentBankAccNo
      );
    });
    setIsBankLinkedToThisPan(bankLinkedToThisPan);

    const isLinkedOnAnotherAccount =
      isPanChangedFromOriginal &&
      lookupAccounts.some(
        (val) => val?.bank_acc_no === currentBankAccNo && val?.id !== id,
      );

    if (isBankLinkedToThisPan) {
      setAlreadyLinked(true);
      setIsLinkedAccount(false);
      BenEnableNextButton(true);
      setCurrentAssociate(
        isBankLinkedToThisPan?.type_of_account === "field_force"
          ? "Field force account"
          : isBankLinkedToThisPan?.type_of_account === "reimbursement"
            ? "Reimbursement account"
            : isBankLinkedToThisPan?.type_of_account === "tds"
              ? "Tax account"
              : "Beneficiary account",
      );
      setAccActiveInactiveState(
        isBankLinkedToThisPan?.approval_status === "rejected" ||
          isBankLinkedToThisPan?.approval_status === "blocked" ||
          isBankLinkedToThisPan?.approval_status === "archived"
          ? "inactive"
          : "active",
      );
    } else if (isLinkedOnAnotherAccount) {
      setAlreadyLinked(false);
      setIsLinkedAccount(true);
      BenEnableNextButton(true);
    } else {
      setAlreadyLinked(false);
      setIsLinkedAccount(false);
    }
  }, [
    allData,
    panLookupData,
    panLookupLoading,
    verifiedPan,
    payload.panNumber,
    currentBankAccNo,
    fieldForceAccount?.pan_no,
    id,
  ]);

  const handleNext = () => {};

  const handleBack = () => {
    if (nextButtonEnabled && !openPopEditCheck) {
      navigate(
        `/field_force_account_dashboard/field_force_account_view_all/field_force_account_detail_page/${id}`,
      );
    } else if (openPopEditCheck) {
      setOpenPopEdit(true);
    } else {
      setOpenPopEdit(true);
    }
  };

  useEffect(() => {
    const fetchPANData = async () => {
      let response = await dispatch(getSpecificFieldForceAccount({ id: id }));
      if (response?.error?.message === "Request failed with status code 404") {
        navigate("*");
      }
    };
    fetchPANData();
  }, [dispatch, id, navigate]);

  const initializedRef = useRef(false);

  useEffect(() => {
    if (
      initializedRef.current ||
      getSpecificFieldForceAccountLoading ||
      !getSpecificFieldForceAccountData?.status
    ) {
      return;
    }

    initializedRef.current = true;
    setIsFocus(true);

    const fieldForceAccount =
      getSpecificFieldForceAccountData.field_force_accounts?.[
        GlobalConfiguration.lengthCheckZero
      ];

    setPayload((prev) => ({
      ...prev,
      panNumber: fieldForceAccount?.pan_no,
      gstin: fieldForceAccount?.gstin_detail,
      legalName: fieldForceAccount?.pan_legal_name || prev.legalName,
    }));

    if (services?.includes("FFUAccount") || services?.includes("Admin")) {
      pendingVerifyPanRef.current = fieldForceAccount?.pan_no || null;

      dispatch(
        verifyPAN({
          pan_number: fieldForceAccount?.pan_no,
          navigate,
        }),
      );
    } else {
      navigate("/feature_not_assigned", {
        state: { unavailableService: "FFUAccount" },
      });
    }
  }, [
    getSpecificFieldForceAccountLoading,
    getSpecificFieldForceAccountData,
    services,
    dispatch,
    navigate,
  ]);

  const isPanLinkBlocked = (isLinkedAccount || alreadyLinked) && verifiedPan;
  const isFullPanEntered =
    payload.panNumber?.length === GlobalConfiguration.panLength;
  const lookupRecordCount =
    panLookupData?.title?.records ?? GlobalConfiguration.lengthCheckZero;
  const isLookupForCurrentPan = lastLookupRef.current.pan === payload.panNumber;
  const isAwaitingFirstLookupResponse =
    verifiedPan === true &&
    isLookupForCurrentPan &&
    !panLookupLoading &&
    panLookupData == null &&
    !panLookupError;
  const isLookupPaginationPending =
    verifiedPan === true &&
    isLookupForCurrentPan &&
    !panLookupError &&
    lookupRecordCount >
      (allData?.length ?? GlobalConfiguration.lengthCheckZero);
  const isAssociatedLookupPending =
    isFullPanEntered &&
    (panVerificationLoading ||
      panLookupLoading ||
      isAwaitingFirstLookupResponse ||
      isLookupPaginationPending);
  const shouldNextBtnBeEnabled =
    isAssociatedLookupPending || panVerificationLoading || isPanLinkBlocked
      ? false
      : !nextButtonEnabled;
  const dataArray = [
    {
      previousText: "Cancel",
      nextText: "Update",
      stepperText: "PAN details",
      previousEnableBgColor: "var(--primary-nav-act)",
      previousDisableBgColor: "var(--primary-nav-act)",
      nextEnableBgColor: "var(--positive-act)",
      nextDisableBgColor: !cancelBut && "var(--text-disabled)",
      nextIsEnabled:
        verifiedPan === true && panLookupError === true
          ? shouldNextBtnBeEnabled && !updateActive
          : handleUpdateNext && shouldNextBtnBeEnabled && !updateActive,
      nextHoverOption: "black",
      nextIsLoading: cancelBut ? true : false,
      nextLoaderNeeded: true,
    },
  ];

  const handleUpdateAccount = () => {
    if (updateActive || isPanLinkBlocked || isAssociatedLookupPending) return;
    setUpdateActive(true);
    setCanclebtn(true);
    const fieldForceAccount =
      getSpecificFieldForceAccountData?.field_force_accounts?.[
        GlobalConfiguration.lengthCheckZero
      ];
    const linkedUserId =
      fieldForceAccount?.field_force_user_id ||
      fieldForceAccount?.linked_user_id ||
      null;
    const resolvedName =
      payload?.legalName ||
      fieldForceAccount?.name ||
      fieldForceAccount?.pan_legal_name ||
      "";
    setTimeout(() => {
      dispatch(
        editFieldForceAccount({
          id: id,
          pan: payload.panNumber,
          name: resolvedName,

          linked_user_id: linkedUserId,
          navigate,
        }),
      );
    }, 1000);
    setAccountType({ type: "", id: "" });
    setIsArchived(false);
    setIsApproved(false);
    setIsDennied(false);
    setIsPending(false);
    setShowAction(false);
  };

  useEffect(() => {
    if (editFieldForceAccountData?.status === true) {
      const previousData =
        getSpecificFieldForceAccountData?.field_force_accounts?.[
          GlobalConfiguration.lengthCheckZero
        ];
      const updatedFields = [];
      if (previousData?.pan_no !== payload.panNumber) {
        updatedFields.push("pan_no");
      }
      if ((previousData?.gstin_detail || "") !== (payload.gstin || "")) {
        updatedFields.push("gstin_detail");
      }
      navigate(
        `/field_force_account_dashboard/field_force_account_view_all/field_force_account_detail_page/edit_PAN_details_success/${id}`,
        {
          state: {
            updatedFields:
              updatedFields.length > GlobalConfiguration.lengthCheckZero
                ? updatedFields
                : ["pan_no"],
          },
          replace: true,
        },
      );
      localStorage.setItem("haveAssociated", JSON.stringify(panLookupError));
      dispatch(resetEditFieldForceAccount());
    }
    if (editFieldForceAccountError) {
      setUpdateActive(false);
    }
  }, [editFieldForceAccountData, editFieldForceAccountError]);

  useEffect(() => {}, []);

  useEffect(() => {
    if (!isLoading && services != null) {
      if (services?.includes("FFUAccount") || services?.includes("Admin")) {
      } else {
        navigate("/feature_not_assigned", {
          state: { unavailableService: "FFUAccount" },
        });
      }
    }
  }, [services, isLoading]);

  const handlePanChange = (e) => {
    const inputPan = e.target.value.toUpperCase();

    if (inputPan?.length < GlobalConfiguration.panLength) {
      setOpenPopEditCheck(true);
      setAlreadyLinked(false);
      setIsLinkedAccount(false);
      setAllData([]);
      setPage(1);
      cachedLookupPanRef.current = null;
      cachedLookupAccountsRef.current = [];
    }
    if (panRegex.test(inputPan)) {
      setOpenPopEditCheck(true);
    }
    if (
      getSpecificFieldForceAccountData?.field_force_accounts?.[
        GlobalConfiguration.lengthCheckZero
      ]?.pan_no === inputPan
    ) {
      setOpenPopEditCheck(false);
    }

    if (!specialRegex.test(inputPan)) {
      return;
    }

    if (inputPan?.length > GlobalConfiguration.panLength) {
      return;
    }
    if (
      !panRegex.test(inputPan) &&
      inputPan?.length === GlobalConfiguration.panLength
    ) {
      setVerifiedPan(false);
      CommonToast({
        text: "Invalid PAN",
        icon: ICONS?.INFO_FILLED,
        variant: "var(--error)",
        buttonNeeded: false,
      });

      dispatch(resetPanLookup());
      setPayload({
        ...payload,
        gstin: "",
      });
    } else if (inputPan?.length === GlobalConfiguration.panLength) {
      if (verifyDebounceRef.current) {
        clearTimeout(verifyDebounceRef.current);
        verifyDebounceRef.current = null;
      }
      if (panRegex.test(inputPan)) {
        dispatch(resetPANVerification());
        dispatch(resetPanLookup());
        cachedLookupPanRef.current = null;
        cachedLookupAccountsRef.current = [];
        lastLookupRef.current = { pan: null, page: null };
        setVerifiedPan(null);
        verifyDebounceRef.current = setTimeout(() => {
          verifyDebounceRef.current = null;
          abortControllerRef.current?.abort();
          abortControllerRef.current = new AbortController();
          pendingVerifyPanRef.current = inputPan;
          retryCountRef.current = GlobalConfiguration.lengthCheckZero;

          if (services?.includes("FFUAccount") || services?.includes("Admin")) {
            dispatch(
              verifyPAN({
                pan_number: inputPan,
                navigate: navigate,
                signal: abortControllerRef.current.signal,
              }),
            );
          } else {
            navigate("/feature_not_assigned", {
              state: { unavailableService: "FFUAccount" },
            });
          }
        }, VERIFY_DEBOUNCE_MS);
      }
      setAllData([]);
      setPage(1);
    } else {
      if (verifyDebounceRef.current) {
        clearTimeout(verifyDebounceRef.current);
        verifyDebounceRef.current = null;
      }
      retryCountRef.current = GlobalConfiguration.lengthCheckZero;
      setVerifiedPan(null);
      BenEnableNextButton(true);
      setLookupNext(false);
      setAccountType({ type: "", id: "" });

      setShowAccInfo(false);
      sessionStorage.removeItem("PAN GST Edit NewValue");
      lastLookupRef.current = { pan: null, page: null };
    }

    setPayload({
      ...payload,
      panNumber: inputPan,
      gstin: "",
    });
    setAccountType({ type: "", id: "" });
    setNewMessage(false);
    setIsArchived(false);
    setIsApproved(false);
    setIsDennied(false);
    setIsPending(false);
    setShowAction(false);
    setIsBlock(false);
    setDisableCreateNext(false);
    setIsActive(false);
    setHideBlock(false);
    setHideCreate(false);
    setNonArchive(false);
    setAlreadyLinked(false);
    setIsLinkedAccount(false);
    setIsBankLinkedToThisPan(null);
    setHandleUpdateNext(false);
  };

  const handleConfirm = () => {
    navigate(
      `/field_force_account_dashboard/field_force_account_view_all/field_force_account_detail_page/${id}`,
    );
  };

  return (
    <div
      className="w-width-full flex flex-col justify-start items-center !h-screen"
      style={{
        overflowY: false ? "hidden" : "hidden",
        height:
          achivedOpenPop || unachivedOpenPop || showRejectTnxPopup
            ? "var(--full-height)"
            : "",
      }}
    >
      {openPopEdit && (
        <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-dark-opacity">
          <SmallPopup
            headerTitle={"Confirm leaving this page?"}
            headerFontWeight="semibold"
            headerFontColor="text-primary"
            textSize="font-md"
            subtext="Leaving this page will not update the changes made."
            btnOneText="Stay"
            btnOneBtnType="button"
            btnOneEnabledBgColor="transparent"
            btnOneHandleFunction={() => setOpenPopEdit(false)}
            btnOneOutLineColor="var(--text-primary)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneIsDisabled={false}
            btnOneHoverOption="white"
            btnTwoText="Leave"
            btnTwoBtnType="button"
            btnTwoHandleFunction={handleConfirm}
            btnTwoEnabledBgColor="var(--negative-act)"
            btnTwoEnabledTextColor="var(--text-primary)"
            btnTwoIsDisabled={false}
            btnTwoHoverOption="black"
          />
        </div>
      )}

      <div className="w-full z-z-index-content relative flex-col justify-center items-center Qsmd:flex hidden">
        <div className="h-navbar-breadcrumb-height" />
        <div className="w-full Qlg:w-std-width relative min-h-stepper-height">
          <PrimaryStepper
            activeStep={0}
            handleForwardAction={handleUpdateAccount}
            handleBackwardAction={handleBack}
            dataArray={dataArray}
          />
        </div>
      </div>

      {/* <div className="Qsmd:h-navbar-breadcrumb-height min-h-[var(--navbar-height)]"></div> */}
      <div className="fixed z-z-index-header w-width-full h-navbar-height flex justify-center items-center Qsmd:hidden">
        <TopNavComponent
          isFormattingNotRequired
          topNavHeader={"Field force account"}
          topNavSubText="PAN details"
          handleBack={handleBack}
        />
        <div
          className={`h-mobile-create-header ${
            verifiedPan === true && panLookupError === true
              ? shouldNextBtnBeEnabled && !updateActive
              : handleUpdateNext && shouldNextBtnBeEnabled && !updateActive
                ? "bg-positive-act cursor-pointer"
                : "bg-text-disabled cursor-not-allowed"
          } fixed bottom-bottom-base w-width-full text-text-primary items-center justify-center flex font-semibold z-z-index-modal Qsmd:hidden`}
          onClick={
            verifiedPan === true && panLookupError === true
              ? shouldNextBtnBeEnabled && !updateActive
              : handleUpdateNext && shouldNextBtnBeEnabled && !updateActive
                ? handleUpdateAccount
                : undefined
          }
        >
          Update
        </div>
      </div>
      <div className="h-navbar-height block Qsmd:hidden flex-shrink-0 flex-grow-0"></div>
      <div className="w-full overflow-auto pb-padding-lg Qsmd:pb-padding-base ">
        <div className="relative">
          <div className="Qsmd:p-padding-md p-padding-sm"></div>
          <FieldForceAccountPanDetails
            showPopup={showPopup}
            setShowPopup={setShowPopup}
            showAccInfo={showAccInfo}
            allData={allData}
            setShowAccInfo={setShowAccInfo}
            associatedPan={associatedPan}
            test={test}
            gstin={payload?.gstin}
            panNumber={payload.panNumber}
            verifiedPan={verifiedPan}
            handlePanChange={handlePanChange}
            panDetails={panVerificationData?.pan_details}
            beneLookData={panLookupData}
            beneLookLoading={panLookupLoading}
            lookupNext={lookupNext}
            setLookupNext={setLookupNext}
            BenEnableNextButton={BenEnableNextButton}
            verifyPANisLoading={panVerificationLoading}
            isAchived={isAchived}
            setIsArchived={setIsArchived}
            setIsApproved={setIsApproved}
            isApproved={isApproved}
            handleNext={handleNext}
            accountType={accountType}
            setAccountType={setAccountType}
            isDennied={isDennied}
            setIsDennied={setIsDennied}
            setIsPending={setIsPending}
            isPending={isPending}
            nextButtonEnabled={nextButtonEnabled}
            shutViewAll={shutViewAll}
            setShutViewAll={setShutViewAll}
            disableCreateNext={disableCreateNext}
            setDisableCreateNext={setDisableCreateNext}
            panLatestData={payload.panNumber}
            isFocus={isFocus}
            setIsFocus={setIsFocus}
            type={"editFlow"}
            showAction={showAction}
            setShowAction={setShowAction}
            previousId={id}
            setIsBlock={setIsBlock}
            isBlock={isBlock}
            isActive={isActive}
            setIsActive={setIsActive}
            setNewMessage={setNewMessage}
            newMessage={newMessage}
            beneLookError={panLookupError}
            setHideBlock={setHideBlock}
            setHideCreate={setHideCreate}
            hideBlock={hideBlock}
            hideCreate={hideCreate}
            setNonArchive={setNonArchive}
            nonArchive={nonArchive}
            previousBankNo={previousBankNo}
            setPreviousBankNo={setPreviousBankNo}
            isLinkedAccount={isLinkedAccount}
            setIsLinkedAccount={setIsLinkedAccount}
            unachivedOpenPop={unachivedOpenPop}
            setUnachivedOpenPop={setUnachivedOpenPop}
            achivedOpenPop={achivedOpenPop}
            setAchivedOpenPop={setAchivedOpenPop}
            alreadyLinked={alreadyLinked}
            setAlreadyLinked={setAlreadyLinked}
            haveLinkNew={haveLinkNew}
            setPayload={setPayload}
            payload={payload}
            showRejectTnxPopup={showRejectTnxPopup}
            setRejectTxnPopup={setRejectTxnPopup}
            accountData={
              getSpecificFieldForceAccountData?.field_force_accounts?.[
                GlobalConfiguration.lengthCheckZero
              ]
            }
            accActiveInactiveState={accActiveInactiveState}
            setAccActiveInactiveState={setAccActiveInactiveState}
            currentAssociate={currentAssociate}
            setCurrentAssociate={setCurrentAssociate}
            id={id}
            isBankLinkedToThisPan={isBankLinkedToThisPan}
            shouldNextBtnBeEnabled={shouldNextBtnBeEnabled}
            updateActive={updateActive}
            setHandleUpdateNext={setHandleUpdateNext}
            handleUpdateNext={handleUpdateNext}
          />
        </div>
      </div>
    </div>
  );
};

export default FieldForceAccountEditPan;
